import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted, watch } from 'vue';
import request from '@/utils/request'


export default /*@__PURE__*/_defineComponent({
  __name: 'CpeDirectorSearch',
  props: {
  modelValue: {
    type: [String,Number],
  },
  name: {
    type: String,
  },
  isStrict: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  mode: {
    type: String,
    default: '',
  },
  prop: {
    type: String,
    default: 'id'
  }
},
  emits: ['update:modelValue', 'update:name', 'changeValues'],
  setup(__props, { emit: __emit }) {

let _searchDebounce: any = null

const suggestionData: any = ref([])

const props = __props

const emits = __emit

const value: any = computed({
  set(val) {
    emits('update:modelValue', val)
  },
  get() {
    return props.modelValue
  },
})
onMounted(() => {
  search('')
})
watch(props, (newVal) => {
  console.log('watch', newVal.modelValue);
  
  if (newVal.modelValue) {
    let name = newVal.name ? newVal.name.split(']')[1] : ''
    if (!suggestionData.value.find(v=>v.value==newVal.modelValue)) {
      request.get(`/api/in/kol/cpe/admin/bd`, {
      username: name,
      pageSize: 200,
      pageNum: 1,
      isCpe: 1,
      }).then((rsp:any) => {
        suggestionData.value = []
        for (let v of rsp.data.list) {
          suggestionData.value.push({
            label: v.username,
            value: v[props.prop]
          })
        }
      })
    }
  }
})

const search = (name) => {
  clearTimeout(_searchDebounce)
  _searchDebounce =  setTimeout(() => {
      try {
        request.get(`/api/in/kol/cpe/admin/bd`, {
          username: name,
          pageSize: 500,
          pageNum: 1,
          isCpe: 1,
        }).then((rsp:any) => {
          suggestionData.value = []
          for (let v of rsp.data.list) {
            suggestionData.value.push({
              label: v.username,
              value: v[props.prop]
            })
          }
        })
      } catch(err){
        console.log('err')
      }
    }, 600)
  
}

const onChange = (item, options) => {
  console.log('onChange',item, options);
  if (item) {
    emits('changeValues', {blogger_name: options.label})
    emits('update:modelValue', item)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: value.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    "show-search": "",
    style: {"width":"100%"},
    allowClear: true,
    "default-active-first-option": false,
    "show-arrow": false,
    "filter-option": false,
    "not-found-content": null,
    options: suggestionData.value,
    onSearch: search,
    onChange: onChange,
    mode: __props.mode,
    disabled: __props.disabled
  }, null, 8, ["value", "options", "mode", "disabled"]))
}
}

})